import React from 'react';

const ErrorMessage = ({ message }) => {
  if (!message) return null;
  
  return (
    <div className="bg-danger/10 border border-danger px-4 py-3 rounded-lg mb-4 flex items-center shadow-sm">
      <svg className="w-5 h-5 mr-3 text-danger" fill="currentColor" viewBox="0 0 20 20">
        <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
      </svg>
      <span className="font-medium text-danger">{message}</span>
    </div>
  );
};

export default ErrorMessage;
